import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import UserAddressForm from 'components/UserAddressForm';
import { SvgIcon } from 'components/SvgIcon';
import { userService } from 'services/UserService';
import Grid from '@material-ui/core/Grid/Grid';
import Button from '@material-ui/core/Button/Button';
import { FieldValidation } from 'components/Field';
import { cartService } from 'services/CartService';
import { paymentService } from 'services/PaymentService';
import { Observable } from 'rxjs/Observable';
import Translate from 'components/Translate';
import { HistoryContext } from 'shared/HistoryContext';
import { History } from 'history';
import AskAddressMessage from './AskAdressMessage';

const styles = require('./askAddress.css');

interface IState extends IStateBase {
  cart: any;
}

export default class AskAddress extends BaseComponent<IState> {
  private history: History;

  finish = async () => {
    if (await this.isFormValid()) {
      userService.setBasicUser()
        .switchMap(() => {
          return Observable.combineLatest(
            cartService.getCart(),
            paymentService.getPaymentResult()
          );
        })
        .loader()
        .bindComponent(this)
        .subscribe(([cart, paymentResult]) => {
          if (paymentResult.redirectTo) {

            Observable
              .never()
              .loader()
              .bindComponent(this)
              .subscribe();

            window.location.href = paymentResult.redirectTo;
            return;
          }

          this.history.push(`/thankyou/${cart.contentId}/${paymentResult.key}`);
        });
    }
  }

  setHistory(history: History): any {
    this.history = history;
    return null;
  }
  componentDidMount() {
    this.observeState({ cart: null }, cartService.getCart());
  }

  render() {

    if (!this.state) {
      return null;
    }

    if (!paymentService.hasPayment()) {
      window.location.replace(`/${this.state.cart.contentId}`);
    }

    return (
      <div>
        <HistoryContext.Consumer>
          {h => this.setHistory(h)}
        </HistoryContext.Consumer>
        <div className={styles.component}>
          <FieldValidation.Provider value={this.registerFields}>
            <div className='chk-askAdress__content'>
              <Grid container>
                <Grid item className='addressAfter' xs={12}>
                  <div className='icon'>
                    <SvgIcon name='check' />
                  </div>
                  <div className='chk-paragraph' >
                    <AskAddressMessage />
                  </div>
                </Grid>
                <div className='form'>
                  <UserAddressForm />
                </div>
                <Button
                  id='chk-askadress-button'
                  className='chk-btn-download theme-button'
                  onClick={this.finish}
                >
                  <Translate term='Concluir' />
                </Button>
              </Grid>
            </div>
          </FieldValidation.Provider>
        </div >
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/AskAddress/index.tsx